module.exports = __webpack_public_path__ + "img/建模标准审核选择.fac7c00e.svg";